export function capitalize(string) {
  if (!string) return '';
  const lowercase = string.toLowerCase();
  const stringArray = lowercase.split(' ');
  const capitalizedArray = stringArray.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedArray.join(' ');
}
